export default __webpack_public_path__ + "static/media/github_logo.7fa45dda.svg";